import { ChoiceField } from './ChoiceField';
import type { FormFieldComponent } from './types';

/** No `formSchema`: see `ChoiceField` for why an unfillable field must not be required. */
const GenericFormSalutationField: FormFieldComponent = () => <ChoiceField family="optionLists" role="salutationFormField" />;

export default GenericFormSalutationField;
